import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { ViewableRequest } from '../review-request/review-request.model';
import { Sources, RequestCommentSubmission } from '../../shared/services/request-comments.service';

@Component({
  selector: 'app-request-review-modal',
  templateUrl: './request-review-modal.component.html',
  styleUrls: ['./request-review-modal.component.css']
})
export class RequestReviewModalComponent implements OnInit {

  public request: ViewableRequest;
  public reviewForm: FormGroup;
  public get comment() { return this.reviewForm.get("comment") };

  public onClose: Subject<any> = new Subject<any>();
  public onReviewed: Subject<RequestCommentSubmission> = new Subject<RequestCommentSubmission>();

  constructor(formBuilder: FormBuilder) { 
    this.reviewForm = formBuilder.group({
        comment: formBuilder.control(null)
    });
  }

  ngOnInit() {
  }

  public close(): void {
    this.onClose.next();
  }

  public completeReview(): void {
    var formData = this.reviewForm.value as ReviewFormModel;

    this.onReviewed.next({ 
      requestId: this.request.id,
      comment: formData.comment,
      source: Sources.ReadyForReviewToReviewed
     });
  }
}

interface ReviewFormModel {
  comment: string;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-review-modal/request-review-modal.component.ts